import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { Icon } from "../../components/Icon/Icon";
import WarningIcon from "../../icons/information.svg";
import ErrorIcon from "../../icons/messagebox_error.svg";
import InfoIcon from "../../icons/messagebox_info.svg";
import styles from "./MessageBox.module.scss";
export var MessageBoxVariant;
(function (MessageBoxVariant) {
    MessageBoxVariant["error"] = "variant-error";
    MessageBoxVariant["warning"] = "variant-warning";
    MessageBoxVariant["message"] = "variant-message";
    MessageBoxVariant["info"] = "variant-info";
})(MessageBoxVariant || (MessageBoxVariant = {}));
export const MessageBox = ({ isVisible = true, variant = MessageBoxVariant.error, isCompact = false, title = null, icon, iconSize, children, className, hideIcon = false, isScrollable = true, ...rest }) => {
    let iconElement = icon;
    if (!icon) {
        switch (variant) {
            case MessageBoxVariant.error:
                iconElement = ErrorIcon;
                break;
            case MessageBoxVariant.warning:
                iconElement = WarningIcon;
                break;
            case MessageBoxVariant.message:
                iconElement = InfoIcon;
                break;
            case MessageBoxVariant.info:
                iconElement = InfoIcon;
                break;
        }
    }
    const defaultIconSize = "28px";
    const iconElementSize = iconSize || { width: defaultIconSize, height: defaultIconSize };
    return (_jsxs("div", { "data-js-selector": "message-box", className: classNames(styles.container, styles[variant], className, {
            [styles.compact]: isCompact,
            [styles.hidden]: !isVisible,
            [styles.notScrollable]: !isScrollable,
        }), ...rest, children: [!hideIcon && (_jsx(Icon, { dataTestId: "messageBoxIcon", className: "icon", component: iconElement, width: iconElementSize.width, height: iconElementSize.height })), _jsxs("div", { className: `${styles.content} `, children: [title !== null && (_jsx("header", { children: _jsx("h4", { className: `${styles.heading}`, children: title }) })), children] })] }));
};
//# sourceMappingURL=MessageBox.js.map